<div class="container">
   <ng-template>
      <div class="overlay1 animated-item">
        <span class="loader"></span>
      </div>
    </ng-template>
</div>